const env = process.env.NODE_ENV
const IP = {
  development: { // 本地开发环境
    baseIP: 'https://dev.spbcn.org/web_test/',
    imgUrl: 'https://cdn.spbcn.org/spbcnWeb/nascc/'
  },
  production: { // 生产环境
    baseIP: 'https://dev.spbcn.org/web/',
    imgUrl: 'https://cdn.spbcn.org/spbcnWeb/nascc/'
  },
  test: { // 测试环境
    baseIP: 'https://dev.spbcn.org/web_test/',
    imgUrl: 'https://cdn.spbcn.org/spbcnWeb/nascc/'
  }
}
export default IP[env]
